import { VideoPlayer } from '../../VideoPlayer'
import useVideo from '../../../hooks/useVideo';
import clsx from 'clsx';
import classes from './SliceVideo.module.scss';
import useSlice from '../../../hooks/useSlice';

export function SliceVideo(props) {
    const { currentSequence } = props;
    const { setProgress, progress } = useVideo();
    const { showSlice, currentQuestionTimeAppear } = useSlice();

    return (
        <div className={clsx(classes.videocontainer, (showSlice && currentQuestionTimeAppear === progress) && classes.darkopacity)}>
            <VideoPlayer
                onChangeProgress={(time) => setProgress(time)}
                currentSequence={currentSequence}
            />
        </div>
    )
}

